import { render } from "./BlogArea.vue?vue&type=template&id=5725390d"
import script from "./BlogArea.vue?vue&type=script&lang=js"
export * from "./BlogArea.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__